<template>
    <div>
        <CRow class="pt-4 mb-2">
            <CCol lg="10">
                <h5 class="font-weight-normal d-inline-flex mb-0">
                    {{ $t("management.productManagement") }} 
                </h5>
                <p class="text-muted mb-0 mt-1" style="font-size: 13px;">
                    {{ $t('translateProductHint') }}
                </p>
                <small class="text-dark d-block mt-1 p-1 pl-2" style="font-size: 12px; background-color: #fff3cd; border-left: 3px solid #ffc107; border-radius: 3px;">
                    <i class="fi fi-rr-info mr-1"></i>{{ $t('translateProductNote') }}
                </small>
            </CCol>
            <CCol lg="2">
                <CButton color="warning" block v-if="updateList.length > 0" @click="confirmSaveProductModal = true">
                    {{ $t('save') }} ({{ updateList.length }} {{ $t("item") }})
                </CButton>
            </CCol>
        </CRow>
        <CRow class="mb-2">
            <CCol sm="12" md="3" lg="2" xl="1">
                <div class="sort mb-1 pt-1 pr-1 pl-1"  style="height: 49px;">
                    <select v-model.number="meta_data.limit" class="text-dark form-control "  >
                        <option :value="10">10</option>
                        <option :value="15">15</option>
                        <option :value="20">20</option>
                        <option :value="25">25</option>
                        <option :value="30">30</option>
                        <option :value="35">35</option>
                        <option :value="40">40</option>
                        <option :value="45">45</option>
                        <option :value="50">50</option>
                    </select>
                </div>
            </CCol>
            <CCol xl="8" lg="7" md="9">
                <sortdata  v-on:getSort="setSort" :sort_value="sort_value"
                :sortdata="sortdata"  />
            </CCol>
            <CCol xl="3" lg="3" md="12" class="">
                <div class="sort mb-2 pt-1" style="height: 49px;">
                  <multiselect id="searchcategorySelect" v-model="searchCategory" :options="dataCategory"
                        :search="true" :showLabels="false" :close-on-select="true" :clear-on-select="false"
                        :placeholder="$t('selectCategoryInput')" label="name" track-by="name" @input="setSearch"
                        class="text-dark font-weight-normal  align-items-center" 
                        style=" margin-top: 2px;
                              -webkit-box-align: center !important;
                              -ms-flex-align: center !important;
                              align-items: center !important;" >
                  </multiselect>
                </div>
            </CCol>
        </CRow>
        <div class="row sort p-2 m-0" style="background-color: #f8f9fa; border-radius: 6px; border: 1px solid #e9ecef;">
            <CCol lg="6" md="6" col="6">
                <div class="input-group">
                    <span class="input-group-text">{{ $t('translate') }}</span>
                    <select class="form-control" v-model="translateBy">
                        <option value="name"> {{ $t('name') }}</option>
                        <option value="description">{{ $t('descinformation') }}</option>
                    </select>
                </div>
            </CCol>
            <CCol lg="6" md="6" col="6">
                <div class="input-group">
                    <span class="input-group-text ">{{ $t('targetLanguage') }}</span>
                    <select v-model="selectedLanguage" @change="changeLanguage" class="form-control">
                        <option v-for="lang in languages" :key="lang.value" :value="lang.value">
                            {{ lang.name }}
                        </option>
                    </select>
                    <span class="input-group-text input-icon-right">
                        <img v-bind:src="getFlagIcon(selectedLanguage)" alt="language-icon"
                            class="language-icon lang-icon" />
                    </span>
                </div>
            </CCol>
        </div>
        <DataTable :items="items" :fields="fields" :stickyHeader="true">
            <template #head(select)>
                <div class="text-left mt-1">
                    <div class="custom-checkbox-wrapper">
                        <input type="checkbox" id="selectAll" :checked="areAllSelected"
                            @change="toggleSelectAll" class="custom-checkbox-input" />
                        <label for="selectAll" class="ml-2 mb-0">{{ $t('all') }}</label>
                    </div>
                </div>
            </template>
            <template #head(action)>
                <!-- <select v-model="selectedLanguage" @change="changeLanguage">
                    <option v-for="lang in languages" :key="lang" :value="lang">
                        {{ lang }}
                    </option>
                </select> -->
            </template>
            <template #SKUName="{ item }">
                <td :style="{ 'vertical-align': !item.description ? 'middle' : 'top', width: '50%' }">
                    <div class="d-flex align-items-start">
                        <div class="mr-2 flex-shrink-0" style="width: 50px;">
                            <img
                                v-if="item.remoteImagePath"
                                :src="item.remoteImagePath"
                                class="img-fluid"
                                style="border-radius: 4px; width: 50px; height: 50px; object-fit: cover;"
                            />
                            <div
                                v-else
                                style="width: 50px; height: 50px; border-radius: 4px;"
                                :style="{ backgroundColor: getBGColor(item.indexColor) }"
                            ></div>
                        </div>
                        <div class="flex-grow-1">
                    <p class="mb-0 text-dark">{{ item.SKUName }}  <CBadge color="secondary">{{ item.category && item.category.name ? item.category.name : '-' }}</CBadge></p>
                    <small
                        class="text-dark" v-if="item.description"
                        :class="{ 'clamp-text': !isExpanded(item.objectId) }" 
                        style="color: gray; white-space: pre-wrap;"
                        >
                        {{ item.description || '' }}
                    </small>
                    <CBadge
                        v-if="isClamped(item.description)"
                        @click="toggleExpanded(item.objectId)"
                        class="text-primary"
                        style="cursor: pointer;"
                        >
                        {{ isExpanded(item.objectId) ? $t('seeless') : $t('seemore') }}
                    </CBadge>

                        </div>
                    </div>
                </td>
            </template>
            <template #select="{ item }">
                <td class="text-left">
                    <div class="custom-checkbox-wrapper">
                        <input type="checkbox" :id="'checkbox-' + item.objectId" :value="item.objectId"
                            v-model="selectedItems" class="custom-checkbox-input" />
                        <label :for="'checkbox-' + item.objectId"></label>
                    </div>
                </td>
            </template>
            <template #description="{ item }">
                <td>
                    <textarea
                        :id="'desInput_' + index"
                        :value="getDescriptionTranslation(item)"
                        @input="updateItem(index, 'description', $event.target.value)"
                        class="form-control text-dark " disabled
                        rows="1"
                        :placeholder="$t('fillProductDetail')"
                        />
                </td>
            </template>
            <template #action="{ item , index}">
               
                <td v-if="translateBy === 'name'" style="vertical-align: top;">
                    <input
                        :id="'skuNameInput_' + index"
                        :value="getNameTranslation(item)"
                        @input="updateItem(index, 'nameTranslation[' + selectedLanguage + ']', $event.target.value)"
                        class="form-control input-green-border"
                        :placeholder="$t('translateInputPlaceholder') + ' (' + getSelectedLanguageName() + ')'"
                    />
                    <!-- <div class="text-muted mt-1 small" v-if="item.estimatedTokens">
                        <img src="/img/languages/silom-token.png" style="width: 18px; height: 18px;" class="mr-1" /> {{ $t('Token') }}: {{ item.estimatedTokens.tokenCount }}
                    </div> -->
                </td>
                <td v-if="translateBy === 'description'" style="vertical-align: top;">
                    <textarea
                        :id="'desInput_' + index"
                        :value="getDescriptionTranslation(item)"
                        @input="updateItem(index, 'descriptionTranslation[' + selectedLanguage + ']', $event.target.value)"
                        class="form-control medium input-green-border"
                        rows="5"
                        :placeholder="$t('fillProductDetail')"
                    />
                    <!-- <div class="text-muted mt-1 small" v-if="item.estimatedTokens">
                        <img src="/img/languages/silom-token.png" style="width: 18px; height: 18px;" class="mr-1" /> {{ $t('Token') }}: {{ item.estimatedTokens.tokenCount }}
                    </div> -->
                </td>
            </template>
            <template #translate="{ item ,index}">
                <td class="text-center mr-2" style="vertical-align: top;margin-top:5px;" @click="getTranslationByItem(index)" >
                    <template v-if="item.isTranslating">
                        <CSpinner size="sm" />
                    </template>
                    <template v-else>
                        <img src="/img/languages/Ai.png"  style="width: 25px; height: 25px;"   class="mr-2"
                            :title="`Token: ${item.estimatedTokens?.tokenCount || 0}`"
                            v-c-tooltip="{ content: `Token: ${item.estimatedTokens?.tokenCount || 0}`, placement: 'left' }"/> 
                    </template>                
                </td>
            </template>
        </DataTable>
        <pagination  :meta_data="meta_data" v-on:next="getProduct">
        </pagination>
        <CModal :show.sync="confirmSaveProductModal" id="confirmSaveProductModal" size="lg" centered>
            <template #header>
                <h5 class="modal-title">
                    <i class="fi fi-rr-check-circle text-success mr-2"></i>
                    {{ $t('save') }} — {{ $t("product") }}
                    <CBadge color="success" class="ml-2">{{ updateList.length }} {{ $t("item") }}</CBadge>
                </h5>
                <button type="button" class="close" @click="confirmSaveProductModal = false">
                    <span>&times;</span>
                </button>
            </template>
            <div style="max-height: 400px; overflow-y: auto;">
                <table class="table table-sm table-hover mb-0">
                    <thead class="thead-light" style="position: sticky; top: 0; z-index: 1; background: #f8f9fa;">
                        <tr>
                            <th style="width: 40%;">{{ $t("productName") }}</th>
                            <th>{{ $t("translate") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in updateList" :key="index">
                            <td style="vertical-align: top; padding-top: 12px;">
                                <div class="d-flex align-items-start">
                                    <img v-if="item.remoteImagePath" :src="item.remoteImagePath"
                                        style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; flex-shrink: 0;" class="mr-2" />
                                    <div v-else style="width: 40px; height: 40px; border-radius: 4px; flex-shrink: 0;"
                                        :style="{ backgroundColor: getBGColor(item.indexColor) }" class="mr-2"></div>
                                    <div>
                                        <span class="text-dark">{{ item.SKUName }}</span>
                                        <br><small class="text-muted">{{ item.category && item.category.name ? item.category.name : '' }}</small>
                                    </div>
                                </div>
                            </td>
                            <td style="vertical-align: top; padding-top: 12px;">
                                <small v-if="Object.keys(getChangedNameTranslations(item)).length > 0" class="text-dark font-weight-bold d-block mb-1">{{ $t('productName') }}:</small>
                                <div v-for="(value, lang) in getChangedNameTranslations(item)" :key="'name-' + lang">
                                    <span v-if="value" class="d-block" style="line-height: 1.6;">
                                        <img :src="getFlagIcon(lang)" style="width: 18px; height: 18px; border-radius: 50%; margin-right: 4px;" />
                                        <span class="text-success">{{ value }}</span>
                                    </span>
                                </div>
                                <div v-if="Object.keys(getChangedDescTranslations(item)).length > 0" :class="{ 'mt-2 pt-2': Object.keys(getChangedNameTranslations(item)).length > 0 }" :style="Object.keys(getChangedNameTranslations(item)).length > 0 ? 'border-top: 1px dashed #e0e0e0;' : ''">
                                    <small class="text-dark font-weight-bold d-block mb-1">{{ $t('productDes') }}:</small>
                                </div>
                                <div v-for="(value, lang) in getChangedDescTranslations(item)" :key="'desc-' + lang">
                                    <small v-if="value" class="d-block text-muted" style="line-height: 1.4;">
                                        <img :src="getFlagIcon(lang)" style="width: 14px; height: 14px; border-radius: 50%; margin-right: 4px;" />
                                        {{ value.substring(0, 40) }}{{ value.length > 40 ? '...' : '' }}
                                    </small>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <template #footer>
                <CButton color="light" @click="confirmSaveProductModal = false">{{ $t('cancel') }}</CButton>
                <CButton color="success" @click="saveEditProduct()" :disabled="loadingSaveProduct">
                    <CSpinner v-if="loadingSaveProduct" size="sm" class="mr-1" />
                    <i v-else class="fi fi-rr-disk mr-1"></i>
                    {{ $t('save') }}
                </CButton>
            </template>
        </CModal>

    </div>
</template>
<script>
import { mapGetters } from "vuex";
import DataTable from "@/containers/DataTable";
import util from "@/util/util";
import pos from "@/services/local";
import Sortdata from "@/containers/SortData";
import Pagination from "@/containers/Pagination";
import axios from "@/services/service";
import Multiselect from "vue-multiselect";
import openrouter from '@/services/openrouterapi'
export default {
    data(){
        return {
            data : [],
            selectedLanguage: 'en',
            languages: [
                { value: 'th', name: 'ไทย', img: '/img/languages/flag_TH01.png' },
                { value: 'en', name: 'English', img: '/img/languages/flag_EN01.png' },
                { value: 'lo', name: 'ລາວ', img: '/img/languages/flag_LA01.png' },
                { value: 'my', name: 'မြန်မာ', img: '/img/languages/flag_MM01.png' },
                { value: 'zh', name: 'Chinese', img: '/img/languages/flag_China01.png' },
                { value: 'ja', name: '日本語', img: '/img/languages/flag_JP01.png' },
                { value: 'km', name: 'ភាសាខ្មែរ', img: '/img/languages/flag_Cambodia01.png' },
                { value: 'ko', name: '한국어', img: '/img/languages/ko.png' },
                { value: 'hi', name: 'हिन्दी', img: '/img/languages/flag_India01.png' },
                { value: 'id', name: 'Bahasa Indonesia', img: '/img/languages/flag_Indo01.png' },
                { value: 'ar', name: 'العربية', img: '/img/languages/flag_Arab01.png' }
            ],
            selectedItems: [],
            translateBy : 'name',
            sort_value: {
                name: "SKUName",
                updated_at: "updated_at",
                category: "category.name"
            },
            sortdata: this.$route.query.sort || "SKUName",
            meta_data: {
                last_page: null,
                current_page: 1,
                prev_page_url: null,
                items: 0,
                limit: 50,
                itemCount: 0,
            },
            updateList: [],
            dataCategory : [],
            expanded: false,
            expandedItems: {},
            searchCategory :  "",
            confirmSaveProductModal :  false,
            loadingSaveProduct  : false,
            originalData:[],
            totalTokenCount : 0

        }
    },
    watch: {
        'meta_data.limit'(newLimit, oldLimit) {
            this.getProduct()
        },
        // 'translateBy'(newEstimateTokens, oldEstimateTokens) {
        //     this.estimateTokens()
        // },
        shopObjectId(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getCategory();
                this.getProduct()
            }
        }
    },
    computed: {
        ...mapGetters(["shops", "users", "date"]),
        selectedTokenCount() {
            return this.data
            .filter((item) => this.selectedItems.includes(item.objectId))
            .reduce((sum, item) => {
                return sum + (item.estimatedTokens?.tokenCount || 0);
            }, 0);
        },
        shopObjectId: {
            get() {
                return this.$store.getters.shopObjectId;
            },
            set(newValue) {
                return this.$store.dispatch("setShop", newValue);
            }
        },
        areAllSelected() {
            return this.data.length > 0 && this.selectedItems.length === this.data.length;
        },
        fields() {
            let fields = [
                // { key: "select", label: "",   _style: 'width:10%;vertical-align: top;' ,_classes: 'text-left font-weight-normal text-dark',},
                { key: "SKUName", label: this.$t("productName") ,  _style: 'width:50%; vertical-align: top;' ,_classes: 'text-left font-weight-normal text-dark',},
                // { key: "description", label: this.$t("description") ,  _style: 'width:35%;style="vertical-align: top;"',_classes: 'text-left font-weight-normal text-dark',},
                // { key: "nameTranslation", label: this.$t("productName") },
            ];
            fields.push(
                { key: "action", label: this.getSelectedLanguageName(),  _style: 'width:40%; vertical-align: top;' ,_classes: 'text-left font-weight-normal text-dark',},
                // { key: "translate", label: this.$t(""),  _style: 'width:50px;style="vertical-align: top;"' ,_classes: 'text-left font-weight-normal text-dark',}
            );

            return fields;
        },
        // items() {
        //     let data = this.data;

        //     let detail = [];
        //     for (let i = 0; i < data.length; i++) {
        //         let itemData = data[i];
        //         // ค้นหา item ใน updateList ที่มี objectId ตรงกัน
        //         let updatedItem = this.updateList.find(
        //         (updated) => updated.objectId === itemData.objectId
        //         );
        //         // ถ้ามี ใช้ข้อมูลจาก updateList
        //         if (updatedItem) {
        //         itemData = { ...updatedItem };
        //         }

    
        //         let PLUCode = itemData.ProductPLU?.PLUCode || "-";
        //         let img = itemData.remoteImagePath || undefined;
        //         let unit = itemData.unit !== undefined ? itemData.unit : {};
        //         let description = itemData.description !== undefined ? itemData.description : "";
        //         let nameTranslation = itemData.nameTranslation || {};
        //         let descriptionTranslation = itemData.descriptionTranslation || {};


        //         detail.push({
        //             SKUName: itemData.SKUName,
        //             unit: unit,
        //             SKUPrice: itemData.SKUPrice,
        //             productSKUObjectId: itemData.objectId,
        //             PLUCode: PLUCode,
        //             ProductPLU : itemData.ProductPLU,
        //             isOnScreen: itemData.isOnScreen,
        //             favorite: itemData.favorite,
        //             skuType: itemData.skuType,
        //             objectId: itemData.objectId,
        //             indexColor: itemData.indexColor,
        //             remoteImagePath: img,
        //             edited: itemData.edited || false,
        //             description: description,
        //             ProductPRU : itemData.ProductPRU,
        //             nameTranslation: nameTranslation,
        //             descriptionTranslation: descriptionTranslation,
        //             category: this.findCategoryNameByObjectId(itemData.category.objectId),
        //         });
        //     }      
        //     return detail;
        // },    
        items() {
          return this.data.map((originalItem) => {
          // เช็คว่ามีการอัปเดตหรือไม่
            const updatedItem = this.updateList.find(
                (u) => u?.objectId === originalItem?.objectId
            );

            const item = updatedItem ? { ...updatedItem } : { ...originalItem };

            // ดึงข้อมูลเบื้องต้น
            const productSKU = item.ProductSKU || {};
     
            // ประมวลผลค่าต่าง ๆ
            const onhandQty = item.skuType === "SV" || item.skuType === "BOM"
                ? "non-stock products"
                : item.onhandQty ?? 0;


            let description = item.description !== undefined ? item.description : "";
            let nameTranslation = item.nameTranslation || {};
            let descriptionTranslation = item.descriptionTranslation || {};
            let img = item.remoteImagePath || undefined;

            return {
                SKUName: item.SKUName || "-",
                unit: item.unit || {},
                onhandQty: util.convertNumber(onhandQty),
                productSKUObjectId: productSKU?.objectId,
                category: item.category ? this.findCategoryNameByObjectId(item.category.objectId) : { name: '-' },
                skuType: item.skuType,
                objectId: item.objectId,
                indexColor: item.indexColor,
                sortPrice: item.SKUPrice,
                created_at: item.created_at,
                edited: item.edited || false,
                ProductSKU: item.ProductSKU,
                newPrice: item.newPrice ? item.newPrice : 0,
                description : description,
                nameTranslation : nameTranslation,
                remoteImagePath: img,
                descriptionTranslation : descriptionTranslation,
                estimatedTokens : item.estimatedTokens,
                ProductPLU : item.ProductPLU,
                ProductPRU :  item.ProductPRU
            };
          });
        },
        queryURL() {
        let searchBy = ''
        let keyword = ''
        
        if(this.searchCategory !== ''){
            searchBy = 'Category.objectId'
            keyword = this.searchCategory.objectId
        }
        return (
            "?sort=" +
            this.sortdata +
            "&page=" +
            this.page +
            "&view=" +
            this.showView +
            "&searchBy=" +
            searchBy +
            "&keyword=" +
            keyword
        );
        },  
        sortAttr: {
            get() {
                let sortdata = this.sortdata;
                if (sortdata == "sortByNumMin" || sortdata == "sortByNumMax") {
                sortdata = "SKUPrice";
                }
                return sortdata;
            },
            set(newValue) {
                return newValue;
            },
        },
    },
    components: {
        DataTable,
        Sortdata,
        Pagination,
        Multiselect
    },
    created() {
        this.getProduct();
        this.getCategory();
        // this.shop = this.shops.find((i) => this.shopObjectId === i.objectId);
    },
    methods: {
        saveEditProduct() {
            let shopObjectId = this.shopObjectId;

            let items = this.updateList.map((item) => {
                return {
                    objectId:  item.ProductPLU.objectId,
                    nameTranslation: item.nameTranslation,
                    descriptionTranslation: item.descriptionTranslation 
                };
            });

            let payload = {
                shopObjectId: shopObjectId,
                mode: "PRODUCT",
                items: items
            };
            let headers = { 
                shopObjectId: util.sanitizeShopObjectId(shopObjectId),
            };

            this.loadingSaveProduct = true;

            pos({
                method: "PATCH",
                url: "/api/v3.0/product/translation/quick", // เปลี่ยน URL ตาม cURL
                data: payload,                              // ใช้ Payload รูปแบบใหม่
                headers: headers,
            })
            .then((res) => {
                console.log(res);

                this.confirmSaveProductModal = false;
                this.loadingSaveProduct = false;
                this.getProduct();
                this.updateList = [];
            })
            .catch((error) => {
                console.log(error);
                this.loadingSaveProduct = false; // คืนค่า loading เมื่อเกิดข้อผิดพลาด
            });
        },
        getBGColor(i) {
            return util.generateColor(i)
        },
        getNameTranslation(item) {
            return item.nameTranslation && item.nameTranslation[this.selectedLanguage]
            ? item.nameTranslation[this.selectedLanguage]
            : '';
        },
        getDescriptionTranslation(item) {
            return item.descriptionTranslation && item.descriptionTranslation[this.selectedLanguage]
            ? item.descriptionTranslation[this.selectedLanguage]
            : '';
        },
        changeLanguage() {
            // Logic to handle language change
        },
        toggleSelectAll() {
            if (this.areAllSelected) {
                this.selectedItems = [];
            } else {
                this.selectedItems = this.data.map(item => item.objectId);
            }
        },
        getFlagIcon(language) {
            const lang = this.languages.find(lang => lang.value === language);
            return lang ? lang.img : '';
        },
        getSelectedLanguageName() {
            const lang = this.languages.find(l => l.value === this.selectedLanguage);
            return lang ? lang.name : this.selectedLanguage;
        },
        getChangedNameTranslations(item) {
            const original = this.originalData.find(o => o.objectId === item.objectId)
            const result = {}
            if (item.nameTranslation) {
                Object.keys(item.nameTranslation).forEach(lang => {
                    const newVal = item.nameTranslation[lang]
                    const oldVal = original?.nameTranslation?.[lang]
                    if (newVal && newVal !== oldVal) {
                        result[lang] = newVal
                    }
                })
            }
            return result
        },
        getChangedDescTranslations(item) {
            const original = this.originalData.find(o => o.objectId === item.objectId)
            const result = {}
            if (item.descriptionTranslation) {
                Object.keys(item.descriptionTranslation).forEach(lang => {
                    const newVal = item.descriptionTranslation[lang]
                    const oldVal = original?.descriptionTranslation?.[lang]
                    if (newVal && newVal !== oldVal) {
                        result[lang] = newVal
                    }
                })
            }
            return result
        },
        setSort(value) {
            this.sortdata = value;
            this.getProduct();
        },
        setSearch(searchBy, keyword) {
            this.keyword = keyword;
            this.searchBy = searchBy;
            this.getProduct();
        },
        findCategoryNameByObjectId(targetObjectId) {
            let categoryList = this.dataCategory;
            return categoryList.find(item => item.objectId === targetObjectId) || null
        },
        getProduct(page = this.$route.query.page || 1) {
            this.searchLoadingButton = false;
            this.loadingButton = false;
            const shopObjectId = this.shopObjectId;
            const headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId)};

            let sortOrder = "";
            if (this.sortdata == "sortByNumMin") {
                sortOrder = "asc";
            } else if (
                this.sortdata == "sortByNumMax" ||
                this.sortdata == "updated_at"
            ) {
                sortOrder = "desc";
            } else {
                sortOrder = "asc";
            }

            let params = {
                shopObjectId: shopObjectId,
                page: page,
                sortAttr: this.sortAttr,
                sortOrder: sortOrder,
                limit: this.meta_data.limit,
            };
            // Add search attribute.      
            if (this.searchCategory !== null)  {
                // params["searchVal"] = this.keyword;
                params["categoryObjectId"] = this.searchCategory.objectId
            }
            pos({
                url: "/api/v3.0/productsku/quicklist",
                params: params,
                headers: headers,
                method: "GET",
            }).then((res) => {
                
                this.data = res.data.data.map((item) => ({
                    ...item,
                    nameTranslation: item.nameTranslation || {},
                    descriptionTranslation: item.descriptionTranslation || {},
                    edited: false, // รีเซ็ตสถานะการแก้ไข
                    estimatedTokens: {}
                }));
                this.selectedItems =  this.data.map(item => item.objectId);
                this.originalData = JSON.parse(JSON.stringify(this.data));

                if (res.data.paginate.items == undefined) {
                    this.countProduct = 0;
                    this.meta_data.items = 0;
                } else {
                    this.countProduct = res.data.paginate.items;
                    this.meta_data.items = res.data.paginate.items;
                }
                this.meta_data.last_page = res.data.paginate.pageCount;
                this.meta_data.current_page = res.data.paginate.currentPage;
                this.meta_data.itemCount = res.data.paginate.itemCount;
                this.meta_data.limit = res.data.paginate.perPage;
                // this.countlist = res.data.data.length;
                this.searchLoadingButton = true;
                this.loadingButton = true;

                // this.estimateTokens();
            });
        },
        getValueByPath(obj, path) {
            const keys = path.replace(/\[(\w+)\]/g, '.$1').split('.');
            return keys.reduce((acc, key) => acc?.[key], obj);
        },
        setValueByPath(obj, path, value) {
            const keys = path.replace(/\[(\w+)\]/g, '.$1').split('.');
            const lastKey = keys.pop();
            const target = keys.reduce((acc, key) => {
                if (!acc[key]) this.$set(acc, key, {});
                return acc[key];
            }, obj);
            this.$set(target, lastKey, value);
        },
        updateItem(index, field, value) {
            const objectId = this.items[index].objectId;
            const originalItem = this.originalData.find(i => i.objectId === objectId);
            if (!originalItem) return;

            const originalValue = this.getValueByPath(originalItem, field);
            const currentItem = JSON.parse(JSON.stringify(this.items[index])); // clone แบบลึก

            // ✅ เงื่อนไขใหม่: ถ้า value === '' และ key ไม่มีใน original → ลบ key
            const fieldParts = field.replace(/\[(\w+)\]/g, '.$1').split('.');
            let lastKey = fieldParts[fieldParts.length - 1];
            let parentPath = fieldParts.slice(0, -1).join('.');
            let currentParent = this.getValueByPath(currentItem, parentPath);

            if (value === '' && this.getValueByPath(originalItem, field) === undefined) {
                // ถ้ามี key อยู่ใน currentParent → ลบ
                if (currentParent && currentParent.hasOwnProperty(lastKey)) {
                delete currentParent[lastKey];
                }
            } else {
                // เซ็ตค่าปกติ
                this.setValueByPath(currentItem, field, value);
            }

            // เปรียบเทียบใหม่หลังจากแก้ไข
            const newValue = this.getValueByPath(currentItem, field);
            if (originalValue === newValue || (originalValue === undefined && newValue === undefined)) {
                const idx = this.updateList.findIndex(i => i.objectId === objectId);
                if (idx !== -1) this.updateList.splice(idx, 1);
                this.items[index].edited = false;
                return;
            }

            const existingIndex = this.updateList.findIndex(i => i.objectId === objectId);
            if (existingIndex === -1 && this.updateList.length >= 100) {
                this.desAlertText = this.$i18n.t('valedateSelectEdititem');
                this.syncValidateCounter = 5;
                return;
            }

            // Apply change to this.items[index] as well
            if (value === '' && this.getValueByPath(originalItem, field) === undefined) {
                const itemParent = this.getValueByPath(this.items[index], parentPath);
                if (itemParent && itemParent.hasOwnProperty(lastKey)) {
                delete itemParent[lastKey];
                }
            } else {
                this.setValueByPath(this.items[index], field, value);
            }

            this.items[index].edited = true;

            if (existingIndex !== -1) {
                this.updateList.splice(existingIndex, 1, currentItem);
            } else {
                this.updateList.push(currentItem);
            }

        },
        getCategory() {
            const uid = `${localStorage.getItem("shopsUid")}`;
            const shopObjectId = this.shopObjectId;
            let params = {
                page: 1,
                limit: 1000,
            };
            const headers = {
                shopObjectId: util.sanitizeShopObjectId(shopObjectId),
            };
            pos
                .get("/api/v1.0/shop/" + uid + "/Category/data/" + shopObjectId, {
                params, headers
                })
                .then((res) => {
                this.dataCategory = res.data.data;
                let data = this.dataCategory;
                for (let i = 0; i < data.length; i++) {
                    // if (data[i].enabled === true) {
                    if (data[i].id == "0") {
                        this.category = {
                        id: data[i].id,
                        name: data[i].name,
                        objectId: data[i].objectId,
                        };
                    // }
                    }
                }
                });
            },
            isClamped(text) {
                if (!text) return false;
                return text.split('\n').length > 4 || text.length > 200;
            },
            isExpanded(id) {
            return this.expandedItems[id] === true;
            },
            toggleExpanded(id) {
            this.$set(this.expandedItems, id, !this.isExpanded(id));
            },
            getTranslationBySelect() {
                const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)};

                // เตรียม nameList จากสินค้าที่ถูกเลือก
                const nameList = this.items
                    .filter((item) => this.selectedItems.includes(item.objectId))
                    .map((item) => ({
                      SKUName: this.translateBy === 'name'
                        ? item.SKUName
                        : item.description || '', // fallback เป็น string เปล่า
                    objectId: item.objectId
                    }));

                if (nameList.length === 0) return;

                const body = {
                    nameList,
                    to: this.selectedLanguage
                };

                this.loadingButton = false;

                openrouter({
                    url: '/api/translate/translatelist',
                    headers,
                    data: body,
                    method: 'POST'
                })
                .then((res) => {

                    const items = res?.data?.data?.items || [];
                    items.forEach((translatedItem) => {
                        const objectId = translatedItem.objectId;
                        const translatedText = translatedItem.translations?.[this.selectedLanguage] || "";
                        const matchedIndex = this.data.findIndex(i => i.objectId === objectId);
                        if (matchedIndex !== -1) {
                        const fieldPath =
                            this.translateBy === 'name'
                            ? `nameTranslation[${this.selectedLanguage}]`
                            : `descriptionTranslation[${this.selectedLanguage}]`;

                        this.updateItem(matchedIndex, fieldPath, translatedText);
                        }
                    });

                    this.loadingButton = true;
                })
                .catch((err) => {
                    console.error('❌ Translation error:', err);
                    this.loadingButton = true;
                });
            },
            estimateTokens() {
                const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)};

                const nameList = this.data.map(item => ({
                    text: this.translateBy === 'name'
                    ? item.SKUName
                    : item.description || '',
                    objectId: item.objectId
                }));

                const data = {
                    nameList,
                    to: this.selectedLanguage,
                };

                openrouter({
                    url: '/api/translate/token-estimate-namelist',
                    headers,
                    data,
                    method: 'POST'
                })
                    .then((res) => {
                    const estimates = res.data?.data?.estimates || [];

                    estimates.forEach((estimate) => {
                        const target = this.data.find(i => i.objectId === estimate.objectId);
                        if (target && estimate.perLanguage?.[this.selectedLanguage]) {
                        target.estimatedTokens = estimate.perLanguage[this.selectedLanguage];
                        }
                    });
                    this.loadingButton = true;
                    })
                    .catch((err) => {
                    console.error('❌ Token estimation failed:', err);
                    this.loadingButton = true;
                    });
            },
            getTranslationByItem(index) {
                const item = this.data[index];
                const shopObjectId = this.shopObjectId;
                const headers = {shopObjectId: util.sanitizeShopObjectId(shopObjectId)}

                const data = {
                    text: this.translateBy === 'name' ? item.SKUName : (item.description || ''),
                    to: this.selectedLanguage
                };

                // แสดงสถานะ loading บางอย่าง (optional)
                this.$set(item, 'isTranslating', true);

                this.loadingButton = false;

                openrouter({
                    url: '/api/translate/check',
                    headers,
                    data,
                    method: 'POST'
                })
                    .then((res) => {
                    const translated = res?.data?.data?.translated || '';
                    const tokens = res?.data?.data?.usage?.total_tokens || 0;

                    const fieldPath = this.translateBy === 'name'
                        ? `nameTranslation[${this.selectedLanguage}]`
                        : `descriptionTranslation[${this.selectedLanguage}]`;

                    this.updateItem(index, fieldPath, translated);
                    item.estimatedTokens = { tokenCount: tokens };
                    })
                    .catch((err) => {
                    console.error('❌ Error translating item:', err);
                    })
                    .finally(() => {
                    item.isTranslating = false;
                    this.loadingButton = true;
                });
            }
    }
}
</script>
<style>
.clamp-text {
  display: -webkit-box;
  -webkit-line-clamp: 4; /* 👈 เปลี่ยนจำนวนบรรทัดที่ต้องการได้ */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.input-green-border {
  border: 1px solid #29b289 !important;
  box-shadow: none;
}
</style>
<style src="../../../assets/styles/multiselect.css"></style>